import type {MouseEvent} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";
import {upperFirst} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";
import {housingEstate, promotionVerbPluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ColumnListItem} from "../../../../atoms/ColumnListItem";
import {OfferBoxBasePanda} from "../../../../atoms/OfferBoxBase";
import {buildFriendlyPromotionSlug} from "../../../../promotion/helpers/build_friendly_promotion_slug";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps, IDynamicPositionProps} from "../../hooks/use_list_dynamic_positions";
import {hitPromotionTileEvent} from "../../tracking/hit_promotion_tile_event";

interface IProps {
    selectedRegion: ISelectedRegion[];
    getDynamicPositionProps: () => IDynamicPositionProps;
    customGridStyle?: {flex: string; maxWidth: string} | null;
    listingPage: number;
    tilePosition: number;
}

export const PromotionsListingTile = (props: IProps) => {
    const {selectedRegion, getDynamicPositionProps, customGridStyle, listingPage, tilePosition} = props;

    const {isMobile} = useUserDevice();

    const promotionOffersCount = selectedRegion.length === 1 && selectedRegion[0].stats ? selectedRegion[0].stats.promotions_count_total : 0;
    const regionName = selectedRegion[0]?.name_declension_where ? upperFirst(selectedRegion[0].name_declension_where) : "W tej lokalizacji";

    const promotionTileDataId = `promotion-tile-${listingPage}-${tilePosition}`;

    useElementWasVisible({
        ids: [promotionTileDataId],
        onElementVisible: () => {
            hitPromotionTileEvent("view", eventParams);
        },
        once: true,
        disabled: promotionOffersCount === 0
    });

    if (promotionOffersCount === 0) return null;

    const promotionListingLink = rpAppLink.promotions.listFriendly({
        friendlySlug: buildFriendlyPromotionSlug({region: selectedRegion?.[0]?.slug})
    });

    const eventParams = {
        redirectPath: promotionListingLink,
        tilePosition,
        listingPage,
        promotionOffersCount
    };

    const handleTileClick = () => {
        hitPromotionTileEvent("click", {...eventParams, customLabel: "tile"});
    };

    const handleCtaClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        hitPromotionTileEvent("click", {...eventParams, customLabel: "cta"});
    };

    return (
        <ColumnListItem
            dynamicProps={isMobile ? disableDynamicPositionProps() : getDynamicPositionProps()}
            className="rp-filters-tile"
            customGridStyle={customGridStyle}
        >
            <OfferBoxBasePanda>
                <a data-id={promotionTileDataId} href={promotionListingLink} className={wrapper} onClick={handleTileClick}>
                    <div className={content}>
                        <PercentIcon size="11.2" wrapperSize="11.2" />

                        <Text variant="headline_3" as="p" align="center" className={text}>
                            {regionName} {promotionVerbPluralize(promotionOffersCount)} {promotionOffersCount} {housingEstate.nominative(promotionOffersCount)}{" "}
                            z promocjami
                        </Text>
                    </div>

                    <Button as="div" variant="filled_secondary" fullWidth onClick={handleCtaClick}>
                        Sprawdź oferty promocyjne
                    </Button>
                </a>
            </OfferBoxBasePanda>
        </ColumnListItem>
    );
};

const wrapper = css({
    width: "100%",
    height: "100%",
    backgroundColor: "var(--colors-highlight)",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "466px",
    color: "inherit",
    textDecoration: "none",
    borderRadius: "var(--radii-2)",

    "&, &:link, &:visited, &:hover, &:active, &:focus": {
        color: "inherit",
        textDecoration: "none"
    }
});

const content = css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});

const text = css({
    maxWidth: "277px",
    mt: "60px"
});
import type {MouseEvent} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";
import {upperFirst} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";
import {housingEstate, promotionVerbPluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ColumnListItem} from "../../../../atoms/ColumnListItem";
import {OfferBoxBasePanda} from "../../../../atoms/OfferBoxBase";
import {buildFriendlyPromotionSlug} from "../../../../promotion/helpers/build_friendly_promotion_slug";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps, IDynamicPositionProps} from "../../hooks/use_list_dynamic_positions";
import {hitPromotionTileEvent} from "../../tracking/hit_promotion_tile_event";

interface IProps {
    selectedRegion: ISelectedRegion[];
    getDynamicPositionProps: () => IDynamicPositionProps;
    customGridStyle?: {flex: string; maxWidth: string} | null;
    listingPage: number;
    tilePosition: number;
}

export const PromotionsListingTile = (props: IProps) => {
    const {selectedRegion, getDynamicPositionProps, customGridStyle, listingPage, tilePosition} = props;

    const {isMobile} = useUserDevice();

    const promotionOffersCount = selectedRegion.length === 1 && selectedRegion[0].stats ? selectedRegion[0].stats.promotions_count_total : 0;
    const regionName = selectedRegion[0]?.name_declension_where ? upperFirst(selectedRegion[0].name_declension_where) : "W tej lokalizacji";

    const promotionTileDataId = `promotion-tile-${listingPage}-${tilePosition}`;

    useElementWasVisible({
        ids: [promotionTileDataId],
        onElementVisible: () => {
            hitPromotionTileEvent("view", eventParams);
        },
        once: true,
        disabled: promotionOffersCount === 0
    });

    if (promotionOffersCount === 0) return null;

    const promotionListingLink = rpAppLink.promotions.listFriendly({
        friendlySlug: buildFriendlyPromotionSlug({region: selectedRegion?.[0]?.slug})
    });

    const eventParams = {
        redirectPath: promotionListingLink,
        tilePosition,
        listingPage,
        promotionOffersCount
    };

    const handleTileClick = () => {
        hitPromotionTileEvent("click", {...eventParams, customLabel: "tile"});
    };

    const handleCtaClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        hitPromotionTileEvent("click", {...eventParams, customLabel: "cta"});
    };

    return (
        <ColumnListItem
            dynamicProps={isMobile ? disableDynamicPositionProps() : getDynamicPositionProps()}
            className="rp-filters-tile"
            customGridStyle={customGridStyle}
        >
            <OfferBoxBasePanda>
                <a data-id={promotionTileDataId} href={promotionListingLink} className={wrapper} onClick={handleTileClick}>
                    <div className={content}>
                        <PercentIcon size="11.2" wrapperSize="11.2" />

                        <Text variant="headline_3" as="p" align="center" className={text}>
                            {regionName} {promotionVerbPluralize(promotionOffersCount)} {promotionOffersCount} {housingEstate.nominative(promotionOffersCount)}{" "}
                            z promocjami
                        </Text>
                    </div>

                    <Button as="div" variant="filled_secondary" fullWidth onClick={handleCtaClick}>
                        Sprawdź oferty promocyjne
                    </Button>
                </a>
            </OfferBoxBasePanda>
        </ColumnListItem>
    );
};

const wrapper = css({
    width: "100%",
    height: "100%",
    backgroundColor: "var(--colors-highlight)",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "466px",
    color: "inherit",
    textDecoration: "none",
    borderRadius: "var(--radii-2)",

    "&, &:link, &:visited, &:hover, &:active, &:focus": {
        color: "inherit",
        textDecoration: "none"
    }
});

const content = css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});

const text = css({
    maxWidth: "277px",
    mt: "60px"
});
